import React, { useState } from 'react';

import { Ellipse } from '../../types/Ellipse';
import { Image } from '../../types/Image';

import xImage from '../../static/images/close-round.png';

const ClickPanel = (
    { image, ellipses, diffs, setDiff }: { image: Image, ellipses: Ellipse[], diffs: boolean[], setDiff: Function }
) => {
    const [showMiss, setShowMiss] = useState<boolean>(false);
    const [clickX, setClickX] = useState<number>(0);
    const [clickY, setClickY] = useState<number>(0);

    const imageClickHandler = (e: React.MouseEvent<SVGSVGElement>) => {
        let target = e.target as HTMLInputElement;
        if (target.tagName.toLowerCase() === "image" && target.classList.contains("grill-duel-image")) {
            const rect = target.getBoundingClientRect();
            setClickX((e.clientX - rect.x) / rect.width * image.width - 30);
            setClickY((e.clientY - rect.y) / rect.height * image.height - 30);
            setShowMiss(true);
            setTimeout(() => setShowMiss(false), 1000);
        }
    };

    return (
        <>
            <svg version="1.1" className="img-fluid" x="0px" y="0px"
                 width={`${image.width}px`} height={`${image.height}px`} viewBox={`0 0 ${image.width} ${image.height}`}
                 enableBackground={`new 0 0 ${image.width} ${image.height}`}
                onClick={imageClickHandler}
            >
                <image className="grill-duel-image" overflow="visible" width={image.width} height={image.height} href={image.src} />
                {showMiss ? (
                    <image overflow="visible" x={clickX} y={clickY} width="60" height="60" href={xImage} />
                ) : ''}
                {ellipses.map((ellipse, index) => diffs[index] ? (
                    <ellipse key={index} stroke="#ffffff" strokeWidth="10" fill="none"
                             cx={ellipse.centerX} cy={ellipse.centerY}
                             rx={ellipse.radiusX - 5} ry={ellipse.radiusY - 5}
                             transform={`rotate(${ellipse.angle}, ${ellipse.centerX}, ${ellipse.centerY})`}
                    />
                ) : (
                    <ellipse key={index} fillOpacity="0" onClick={() => setDiff(index)}
                             cx={ellipse.centerX} cy={ellipse.centerY}
                             rx={ellipse.radiusX - 5} ry={ellipse.radiusY - 5}
                             transform={`rotate(${ellipse.angle}, ${ellipse.centerX}, ${ellipse.centerY})`}
                    />
                ))}
            </svg>
        </>
    );
};

export default ClickPanel;
